export const isColorLight = color => {
  let r, g, b;

  // Check if the color is in HEX or RGB format
  if (color.indexOf('#') === 0) {
    // Convert HEX to RGB
    const hex = color.replace('#', '');
    r = parseInt(hex.slice(0, 2), 16);
    g = parseInt(hex.slice(2, 4), 16);
    b = parseInt(hex.slice(4, 6), 16);
  } else {
    // Extract RGB values
    const match = color.match(/\d+/g);
    if (match) {
      r = parseInt(match[0]);
      g = parseInt(match[1]);
      b = parseInt(match[2]);
    }
  }

  // Calculate the luminance
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  // return luminance > 128; // Threshold for light/dark, can be adjusted
  return luminance > 150; // Threshold for light/dark, can be adjusted
};
